// extracted by mini-css-extract-plugin
module.exports =  {"root":"_32bbee5fda--root--s0ATo"};